import { Slider, Stack, TextField } from '@mui/material';
import { useRef } from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';

import { isNumber } from '@/ui/utils/form-validations';

interface IProps {
  error?: boolean;
  helperText?: string;
  min?: number;
  max?: number;
  control: Control<FieldValues, any>; // eslint-disable-line
  name: string;
  onBlurSlider?: () => void;
  onChangeSlider?: () => void;
  onChangeCommittedSlider?: () => void;
  onBlurNumericField?: () => void;
  onChangeNumericField?: () => void;
}

export function FSSlider({
  min,
  max,
  control,
  name,
  onBlurSlider,
  onChangeSlider,
  onChangeCommittedSlider,
  onBlurNumericField,
  onChangeNumericField,
}: IProps) {
  const inputReference = useRef<HTMLInputElement>(null);

  const focusInput = () => {
    inputReference.current?.focus();
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      rules={{ validate: isNumber }}
      render={({ field }) => (
        <Stack direction={'row'} alignItems={'center'} gap={2} mt={1}>
          <Slider
            {...field}
            value={Number(field.value)}
            valueLabelDisplay="auto"
            min={min || 0}
            max={max || 100}
            onBlur={() => (field.onBlur(), onBlurSlider?.())}
            onChange={(event: Event, value: number | number[]) => {
              field.onChange(value.toString());
              onChangeSlider?.();
            }}
            onChangeCommitted={() => {
              onChangeCommittedSlider?.();
            }}
          />
          <TextField
            {...field}
            type="number"
            value={field.value}
            InputProps={{ inputProps: { min: min || 0, max: max || 100 } }}
            onBlur={() => {
              field.onBlur();
              onBlurNumericField?.();
            }}
            onChange={(event) => {
              field.onChange(event);
              onChangeNumericField?.();
            }}
            inputRef={inputReference}
            onInput={focusInput}
          />
        </Stack>
      )}
    />
  );
}
